import '../../assets/css/form-validation.css';
import PhoneInputGroup from '../common/PhoneInputGroup';

const ShippingAddress = ({ formik, countries, states, cities, showState, showCity, handleShippingCountryChange, handleShippingStateChange, handleShippingCityChange }) => {

    const countryOptions = countries.map(country => ({
        value: country.id,
        label: country.name,
        iso2: country.iso2,
        phone_code: country.phone_code
    }));

    return (
        <div className="checkout-step">
            <div className="step-header">
                <h3>Shipping Address</h3>
            </div>
            <div className="step-content">
                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control ${formik.touched.shippingName && formik.errors.shippingName ? 'is-invalid' : ''}`}
                        placeholder="Full Name *"
                        value={formik.values.shippingName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="shippingName"
                    />
                    {formik.touched.shippingName && formik.errors.shippingName && (
                        <div className="text-danger">{formik.errors.shippingName}</div>
                    )}
                </div>

                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control ${formik.touched.shippingAddress && formik.errors.shippingAddress ? 'is-invalid' : ''}`}
                        placeholder="Address *"
                        value={formik.values.shippingAddress}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="shippingAddress"
                    />
                    {formik.touched.shippingAddress && formik.errors.shippingAddress && (
                        <div className="text-danger">{formik.errors.shippingAddress}</div>
                    )}
                </div>

                <div className="row">
                    <div className="col-12">
                        <PhoneInputGroup
                            formik={formik}
                            countryName="shippingCountry"
                            phoneName="shippingMobileNumber"
                            countries={countries}
                            onCountryChange={handleShippingCountryChange}
                            showLabel={false}
                        />
                    </div>

                    {showState && (
                        <div className="form-group col-md-12">
                            <select
                                className={`form-control ${formik.touched.shippingState && formik.errors.shippingState ? 'is-invalid' : ''}`}
                                value={formik.values.shippingState}
                                onChange={(e) => handleShippingStateChange(e)}
                                onBlur={formik.handleBlur}
                                name="shippingState"
                            >
                                <option value="">Select State *</option>
                                {states.map((state) => (
                                    <option key={state.id} value={state.id}>
                                        {state.name}
                                    </option>
                                ))}
                            </select>
                            {formik.touched.shippingState && formik.errors.shippingState && (
                                <div className="text-danger">{formik.errors.shippingState}</div>
                            )}
                        </div>
                    )}
                </div>

                <div className="row">
                    {showCity && (
                        <div className="form-group col-md-6">
                            <select
                                className={`form-control ${formik.touched.shippingCity && formik.errors.shippingCity ? 'is-invalid' : ''}`}
                                value={formik.values.shippingCity}
                                onChange={(e) => handleShippingCityChange(e)}
                                onBlur={formik.handleBlur}
                                name="shippingCity"
                            >
                                <option value="">Select City *</option>
                                {cities.map((city) => (
                                    <option key={city.id} value={city.id}>
                                        {city.name}
                                    </option>
                                ))}
                            </select>
                            {formik.touched.shippingCity && formik.errors.shippingCity && (
                                <div className="text-danger">{formik.errors.shippingCity}</div>
                            )}
                        </div>
                    )}

                    <div className="form-group col-md-6">
                        <input
                            type="text"
                            className={`form-control ${formik.touched.shippingZip && formik.errors.shippingZip ? 'is-invalid' : ''}`}
                            placeholder="ZIP code *"
                            value={formik.values.shippingZip}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="shippingZip"
                        />
                        {formik.touched.shippingZip && formik.errors.shippingZip && (
                            <div className="text-danger">{formik.errors.shippingZip}</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShippingAddress; 